/* istanbul ignore next */
(function(angular) {
    'use strict';
    angular.module('onvio.setup', [
        'bmpRouting',
        'ui.router',
        'ngCookies',
        'ngSanitize',
        'ngMessages',
        'ui.bootstrap',
        'ui.bootstrap.modal',
        'wj',
        'fef',

        'pascalprecht.translate',
        'templates-main',
        'bento.wizard',
        'bento.off.canvas.menu',
        'bento.pagination',
        'bento.wizard',
        'bento.toolbar',
        'bento.select',
        'bento.services',
        'bento.modern',
        'bento.modern.ui',

        'bmpErrorHandler',
        'bmpRoutableTabset',
        'bmpCoalescingThrottlerFactory',
        'bmpInputGroupBtnDropdown',
        'bmpRadioButtonGroup',
        'bmpRadioCircleButtonGroup',
        'bmpClearValue',
        'bmpClearValueWhen',
        'bmpClearInvalidValueWhen',
        'bmpSetFormDirtyWhen',
        'bmpInteger',
        'bmpCustomValidation',
        'bmpControlGroup',
        'bmpControlGroupField',
        'bmpRequiredMessage',
        'bmpEmailMessage',
        'bmpEntityCode',
        'bm.practice.common',
        'bmpEnumDropdown',
        'bmpEnumRadio',
        'bmpEnumRadioGroup',
        'bmpEnumRadioButtonGroup',
        'bmpEnumProvider',
        'bmpEnumCombo',
        'bmpSelectTypeahead',
        'bmpSelectDropdown',
        'bmpSelectCombo',
        'bmpSelectController',
        'bmpSelectProvider',
        'bmpGrid',
        'bmpToolbar',
        'bmpWait',
        'bmpGridController',
        'bmpIcons',
        'bmpTabset',
        'bmpCustomTable',
        'bmpWijmoTable',
        'bmpResponsiveTabset',
        'bmpValidationMessages',
        'bmpAngularMessageProviders',
        'bmpProviderUtils',
        'bmpDetailVmUtils',
        'bmpDetailVmFactory',
        'bmpLogger',
        'bmpFeatureToggles',
        'bmpModalHelper',
        'onvio.setup.activities.ActivityListController',
        'onvio.setup.activities.ActivityDetailController',

        'bmpMasterDetail',
        'onvio.setup.list.EngagementTemplate',
        'onvio.setup.list.LateFeeTemplate',
        'onvio.setup.list.EngagementTemplateServiceProxy',
        'onvio.setup.list.LateFeeTemplateServiceProxy',
        'bm.core.setup.firm.FirmDetailController',
        'onvio.setup.migrations',
        'onvio.setup.importExportTest',
        'onvio.setup.importProgress',
        'onvio.setup.importWizard',
        'bmSetupStuff',
        'bmFormatOnBlur',
        'bmCapitalizeOnBlur',
        'bluemoon.components',
        'bluemoon.components.session',
        'bluemoon.components.Notifications',
        'bluemoon.components.NavigationUtils',
        'bluemoon.dms.modal.confirmation',
        'bmpDefaultFocus',
        'onvio.setup.values',
        'internal.tools.clientNotifications',
        'internal.tools.clientNotifications.templates',
        'onvio.setup.appearance',
        'bmpBootstrapAffix',
        'bmpVerifyRelationshipSide',
        'bmpSetHeight',
        'onvio.setup.billingComponentTestPage',

        'bm.core.setup',
        // bm.indirect.tax is needed at this level because it is an optional dependency needed for
        // project templates, projects, engagement templates, engagements. Including it here ensures
        // the $injector will be able to get it when it needs it.
        'bm.indirect.tax',

        // Optional dependency for Onbalance tab on client detail
        'onbalance.onvio.components',
        // TODO - KMS - just adding the "full" .Core for bmpSelectProvider and bmpEnumProvider for now, to get back to original functionality.
        // We should probably refactor to add just the providers needed on the screens where they are needed and then remove these.
        'bmpSelectProvider.Core',
        'bmpEnumProvider.Core',

        'bluemoon.components.timeZoneOffsetInterceptor',
        'bmMultifactorUser',

        'onvio.setup.client.notifications',
        'onvio.setup.notifications'
    ]);

    angular.module('templates-main', []);

    // TODO: what is this? modules should depend on their dependencies directly, not an umbrella module
    angular.module('bmSetupStuff',
        [
            'bmpProviderUtils',
            'bluemoon.components.session'
        ]);

    var UseMockedData = (function() {
        function UseMockedData() {
            this.useMockedData = true;
            this.get = function() { return this.useMockedData; };
            this.set = function(value) { this.useMockedData = value; };
        }
        return UseMockedData;
    }());

    angular.module('onvio.setup').
        service('useMockedData', UseMockedData);

    angular.module('onvio.setup.values', []).value(
        'onvio.setup.values.defaultTypeaheadThrottleDelay', 350);

    angular.module('onvio.setup').config([
        'bmpBootstrapAffixConfigProvider', function bootstrapAffixConfig(bootstrapAffixConfigProvider) {
            bootstrapAffixConfigProvider.offset = {
                top: 60
            };
        }
    ]);

    /* The following code sets up necesssary A11Y functionality to some of the UIBootstrap directives. */
    angular.module('onvio.setup')
        .directive('uibTooltip', function() {
            return {
                link: function(scope, element, attrs) {
                    if (attrs.ariaLabel) { return; }
                    attrs.$set('ariaLabel', attrs.uibTooltip);
                    attrs.$observe('uibTooltip', function() {
                        attrs.$set('ariaLabel', attrs.uibTooltip);
                    });
                }
            };
        })
        .config(['$uibTooltipProvider', function($uibTooltipProvider) {
            $uibTooltipProvider.options({ 'trigger': 'mouseenter focus' });
        }]);

    angular.module('onvio.setup')
        .directive('bentoWizard', function() {
            return {
                link: function(scope, element) {
                    element.ready(function() {
                        var selectedWizardStep = angular.element(element).find('ol > li');
                        var observer = new MutationObserver(function() {
                            var wizardSteps = element[0].querySelectorAll('.bento-wizard-step');

                            for (var i = 0; i < wizardSteps.length; i++) {
                                wizardSteps[i].children[0].innerHTML = wizardSteps[i].children[0].innerHTML.replace('.', (' ' + (i + 1) + '.'));

                                if (i === (wizardSteps.length - 1)) {
                                    observer.disconnect();
                                }
                            }
                        });
                        if (selectedWizardStep.length > 0) {
                            observer.observe(selectedWizardStep[0], { attributeFilter: ['class'] });
                        }
                    });
                }
            };
        });

    angular.module('bmpGrid')
        .directive('bmpGrid', function() {
            return {
                link: function(scope, element) {
                    function updateRoleToButton(listElements) {
                        for (var i = 0; i < listElements.length; i++) {
                            var anchorElement = angular.element(listElements[i]).find('a');
                            if (anchorElement && anchorElement.length > 0) {
                                var role = anchorElement[0].getAttribute('role');
                                if (role === 'menuitem') {
                                    anchorElement[0].setAttribute('role', 'button');
                                }
                            }
                        }
                    }

                    element.ready(function() {
                        //  Need to change to role from menuitem to button only for Fixed Free Asset Grid
                        var fixedBillingTemplateGrid = document.querySelector('[data-qe-id="FixedFeeBillingTemplateGrid-grid"]');
                        if (fixedBillingTemplateGrid) {
                            var toolbar = angular.element(document.querySelector('[data-qe-id="FixedFeeBillingTemplateGrid-grid"]')).find('bmp-toolbar')[0];
                            if (toolbar) {
                                updateRoleToButton(angular.element(toolbar).find('ul.navbar-nav > li'));
                            }
                        }
                    });
                }
            };
        });

    angular.module('onvio.setup')
        .directive('uibDatepicker', ['$translate', function($translate) {

            var translatedDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(function(weekDay) {
                return $translate.instant('Core.Captions.WeeklyRecurrence.' + weekDay);
            });

            const KEY_CODES = {
                ESCAPE: 'Escape',
                ESC_IE: 'Esc',
                ESCAPE_CODE: 27
            };

            return {
                link: function(scope, element, attrs) {
                    element.ready(function() {
                        var calendarElement = angular.element(attrs.$$element[0]);
                        var datePickerDateAnnouncementElementId = 'bootstrap-uib-datepicker-date-announcement';

                        document.getElementById(datePickerDateAnnouncementElementId).setAttribute('aria-live', 'polite');
                        var activeClassedButton = angular.element(calendarElement.find('tbody')[0]).find('button.active')[0];
                        let calenderDatePickerModeDiv = document.querySelector('[ng-switch="datepickerMode"] > div');
                        let nodeList;
                        const tabAccessibleButtons = Object.freeze({
                            ENTER: 'Enter',
                            SPACE: 'Space',
                            ARROW_DOWN: 'ArrowDown',
                            ARROW_UP: 'ArrowUp',
                            ARROW_LEFT: 'ArrowLeft',
                            ARROW_RIGHT: 'ArrowRight',
                            TAB: 'Tab'
                        });

                        function addTabAccessibility() {
                            nodeList = document.querySelectorAll('thead > tr > th > button');
                            const spanInsideButton = activeClassedButton.querySelector('span');
                            Array.from(nodeList).map((node) => {
                                node.setAttribute('tabindex', '0');
                                node.addEventListener('keydown', function(event) {
                                    if (event.code === tabAccessibleButtons.TAB) {
                                        const focusable = document.querySelector('[ng-switch="datepickerMode"]').querySelectorAll('[tabindex="0"]');
                                        if (focusable.length) {
                                           const first = focusable[0];
                                           const last = focusable[focusable.length - 1];
                                           const shift = event.shiftKey;
                                           if (shift) {
                                              if (event.target === first) { // shift-tab pressed on first input in dialog
                                                 last.focus();
                                                  event.preventDefault();
                                                  event.stopPropagation();
                                              }
                                            } else {
                                                if (event.target === last) { // tab pressed on last input in dialog
                                                    first.focus();
                                                    spanInsideButton.style.border = '2px solid #b2b2b8';
                                                    first.addEventListener('keydown', function(firstElementEvent) {
                                                        if(firstElementEvent.code === tabAccessibleButtons.TAB) {
                                                            spanInsideButton.style.border = 'none';
                                                        }
                                                    });
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                } else {
                                                    spanInsideButton.style.border = 'none';
                                                }
                                            }
                                        }
                                    } else if (event.code === tabAccessibleButtons.ENTER || event.code === tabAccessibleButtons.SPACE || event.code === tabAccessibleButtons.ARROW_DOWN || event.code === tabAccessibleButtons.ARROW_UP || event.code === tabAccessibleButtons.ARROW_LEFT || event.code === tabAccessibleButtons.ARROW_RIGHT) {
                                        event.stopPropagation();
                                    }
                                });
                            });
                        }

                        addTabAccessibility();

                        var observer = new MutationObserver(function() {
                            //  currentMonthAndYear will have value like this - January 2022
                            var currentMonthAndYear = angular.element(calendarElement.find('thead')[0]).find('.uib-title')[0].children[0].innerHTML;
                            var currentActiveButton = angular.element(calendarElement.find('tbody')[0]).find('button.active')[0];

                            // So replacing space with the date number between the value of currentMonthAndYear like this - January 01 2022
                            var fullDateWithYear = currentMonthAndYear.replace(' ', ' ' + currentActiveButton.children[0].innerHTML + ' ');

                            var date = new Date(fullDateWithYear);
                            var translatedDay = translatedDays[date.getDay()];

                            angular.element(currentActiveButton).attr('aria-labelledby', datePickerDateAnnouncementElementId);
                            document.getElementById(datePickerDateAnnouncementElementId).innerHTML = translatedDay + ', ' + fullDateWithYear;

                            observer.observe(currentActiveButton, { attributeFilter: ['class'] });
                        });

                        var calenderClassSwitchObserver = new MutationObserver(function() {
                            addTabAccessibility();
                            var calenderDatePickerModeCurrentDiv = document.querySelector('[ng-switch="datepickerMode"] > div');
                            if (calenderDatePickerModeCurrentDiv) {
                                calenderDatePickerModeCurrentDiv.focus();
                                calenderClassSwitchObserver.observe(calenderDatePickerModeCurrentDiv, { attributeFilter: ['class'] });

                            }
                        });

                        observer.observe(activeClassedButton, { attributeFilter: ['class'] });
                        calenderClassSwitchObserver.observe(calenderDatePickerModeDiv, { attributeFilter: ['class'] });

                        scope.$on('$destroy', function() {
                            observer.disconnect();
                            document.getElementById(datePickerDateAnnouncementElementId).removeAttribute('aria-live');
                            document.getElementById(datePickerDateAnnouncementElementId).innerHTML = '';

                            calenderClassSwitchObserver.disconnect();
                            Array.from(nodeList).map((node) => {
                                if (event.key === KEY_CODES.ESCAPE || event.key === KEY_CODES.ESC_IE || event.keyCode === KEY_CODES.ESCAPE_CODE) {
                                    const datepickerWrappers = document.querySelectorAll('.bmp-bento-datepicker-wrapper');
                                    datepickerWrappers.forEach(function(wrapper) {
                                        const inputField = wrapper.querySelector('input.form-control');
                                        const datepickerInput = wrapper.querySelector('input[uib-datepicker-popup]');
                                        const datepickerPopup = document.querySelector('body > uib-datepicker-popup-wrap');
                                        if (
                                            document.activeElement === inputField ||
                                            document.activeElement === datepickerInput ||
                                            (datepickerPopup && datepickerPopup.contains(document.activeElement))
                                        ) {
                                            var datePickerButton = wrapper.querySelector('.input-group-btn button[type="button"]');
                                            if (datePickerButton) {
                                                setTimeout(function() {
                                                    datePickerButton.focus();
                                                }, 10);
                                            }
                                        }
                                    });
                                }
                                node.removeEventListener('keydown', () => { });
                            });
                        });

                    });
                }
            };
        }]);

    function uibButtonPressedA11yLink(scope, element, attrs) {
        if (attrs.ariaPressed) { return; }
        var observer = new MutationObserver(function() {
            attrs.$set('ariaPressed', element.hasClass('active'));
        });
        observer.observe(element[0], { attributeFilter: ['class'] });
        scope.$on('$destroy', function() {
            observer.disconnect();
        });
    }

    angular.module('onvio.setup')
        .directive('uibBtnCheckbox', function() { return { link: uibButtonPressedA11yLink }; })
        .directive('uibBtnRadio', function() { return { link: uibButtonPressedA11yLink }; });

    angular.module('onvio.setup')
        .directive('bentoPagination', function() {
            return {
                link: function(scope, element) {

                    element.ready(function() {
                        element.find('li.paginate_button > a').attr('role', 'button');
                        element.find('li.paginate_button.first.first_button > a').attr('aria-labelledby', 'goToFirstPage');
                        element.find('li.paginate_button.previous > a').attr('aria-labelledby', 'goToPreviousPage');
                        element.find('li.paginate_button.next > a').attr('aria-labelledby', 'goToNextPage');
                        element.find('li.paginate_button.last.last_button > a').attr('aria-labelledby', 'goToLastPage');
                        element.find('.bento-select > :first-child').attr('aria-label', 'Items Per page');
                    });
                }
            };
        });

    angular.module('onvio.setup')
        .directive('bentoToolbar', function() {
            return {
                link: function(scope, element) {

                    function addAriaDisabledToListElements(listElements) {
                        for (var i = 0; i < listElements.length; i++) {
                            listElements[i].removeAttribute('aria-checked');
                            var isListElementDisabled = angular.element(listElements[i])[0].hasAttribute('disabled');
                            if (isListElementDisabled) {
                                var anchorElement = angular.element(listElements[i]).find('a');
                                anchorElement.attr('role', 'button');
                                anchorElement.attr('aria-disabled', 'true');
                            }
                        }
                    }

                    element.ready(function() {
                        addAriaDisabledToListElements(element.find('li'));
                    });
                }
            };
        });

    angular.module('onvio.setup')
        .directive('dmsAlert', function() {
            return {
                link: function(scope, element) {
                    element.ready(function() {
                        var alertElements = element.find('button.bento-alert-close');
                        if (alertElements.length > 0) {
                            alertElements[0].setAttribute('tabindex', '-1');
                        }
                    });
                }
            };
        });

    angular.module('onvio.setup')
        .directive('uibTab', function() {
            return {
                link: function(scope, element) {
                    var linkTag = element.find('a');

                    element.attr('role', 'presentation');
                    linkTag.attr('role', 'tab');

                    if (linkTag.attr('ariaSelected')) { return; }

                    linkTag.attr('aria-selected', element.hasClass('active'));
                    var observer = new MutationObserver(function() {
                        linkTag.attr('aria-selected', element.hasClass('active'));
                    });
                    observer.observe(element[0], { attributeFilter: ['class'] });
                    scope.$on('$destroy', function() {
                        observer.disconnect();
                    });
                }
            };
        });

    angular.module('onvio.setup')
        .directive('bmpSelectCombo', function() {
            return {
                link: function(scope, element) {
                    element.ready(function() {
                        var bentoCmb = element.find('[bento-combobox]');
                        var bentoCmbId = bentoCmb.attr('id');
                        var labelEl = element[0] && element[0].parentElement && element[0].parentElement.querySelector('label[for="' + bentoCmbId + '"]');
                        if (labelEl) {
                            var combobox = angular.element(element[0].querySelector('[role="combobox"]'));
                            var labelId = 'label-for-' + bentoCmbId;
                            angular.element(labelEl).attr('id', labelId);
                            combobox.attr('aria-labelledby', labelId);
                        }
                    });
                }
            };
        });
    angular.module('onvio.setup')
        .directive('bentoSideOverlayToggle', [function() {
            return {
                restrict: 'A',
                scope: false,
                link: function(scope, element) {
                    let selectButton;
                    let divElement;
                    element.addClass('bento-side-overlay-toggle noselect');
                    element.ready(function() {
                        selectButton = document.querySelector('.bento-multiselect-overlay-inner > div > button');
                        selectButton.setAttribute('aria-haspopup', true);
                        selectButton.setAttribute('aria-expanded', false);
                        selectButton.addEventListener('click', function() {
                            divElement = angular.element('.bento-multiselect-overlay-inner > div')[0];
                            if (divElement.classList.contains('open')) {
                                selectButton.setAttribute('aria-expanded', true);
                                const popupModal = angular.element('.bento-side-overlay-container')[0];
                                popupModal.setAttribute('role', 'dialog');
                            }
                        });
                        selectButton.addEventListener('focus', function() {
                            selectButton.setAttribute('aria-expanded', false);
                        });
                    });
                }
            };
        }]);
}(window.angular));
